export default "__VITE_ASSET__dc722943__"